if (!customElements.get('tab-group')) {
  customElements.define('tab-group', class TabGroup extends HTMLElement {
    constructor() {
      super();
      this._onTabClick = this._onTabClick.bind(this);
      this._onKeyDown = this._onKeyDown.bind(this);
    }

    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.tabList = this.querySelector('[role="tablist"]');

      if (this.tabList) {
        this.tabList.addEventListener('click', this._onTabClick);
        this.tabList.addEventListener('keydown', this._onKeyDown);
      }
    }

    disconnectedCallback() {
      if (this.tabList) {
        this.tabList.removeEventListener('click', this._onTabClick);
        this.tabList.removeEventListener('keydown', this._onKeyDown);
      }
    }

    _onTabClick(evt) {
      const tab = evt.target.closest('[role="tab"]');
      if (!tab) return;
      this._selectTab(tab);
    }

    _onKeyDown(evt) {
      const idx = this.tabs.indexOf(document.activeElement);
      if (idx === -1) return;

      let next;
      if (evt.key === 'ArrowRight') {
        next = this.tabs[(idx + 1) % this.tabs.length];
      } else if (evt.key === 'ArrowLeft') {
        next = this.tabs[(idx - 1 + this.tabs.length) % this.tabs.length];
      } else if (evt.key === 'Home') {
        next = this.tabs[0];
      } else if (evt.key === 'End') {
        next = this.tabs[this.tabs.length - 1];
      }

      if (next) {
        evt.preventDefault();
        this._selectTab(next);
        next.focus();
      }
    }

    _selectTab(selectedTab) {
      this.tabs.forEach((tab) => {
        const isSelected = tab === selectedTab;
        tab.setAttribute('aria-selected', isSelected);
        tab.classList.toggle('product-details__tab--active', isSelected);
        tab.setAttribute('tabindex', isSelected ? '0' : '-1');
      });

      this.panels.forEach((panel) => {
        const isActive = panel.id === selectedTab.getAttribute('aria-controls');
        panel.classList.toggle('product-details__panel--hidden', !isActive);
      });
    }
  });
}

if (!customElements.get('product-upsells')) {
  customElements.define('product-upsells', class ProductUpsells extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url) return;

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const fragment = new DOMParser().parseFromString(text, 'text/html');
          const upsells = fragment.querySelector('product-upsells');
          if (upsells && upsells.innerHTML.trim().length) {
            this.innerHTML = upsells.innerHTML;
          }
          this._bindAddButtons();
        })
        .catch((e) => {
          console.warn('Failed to load product recommendations:', e);
        });
    }

    _bindAddButtons() {
      this.querySelectorAll('.product-details__upsell-add').forEach((btn) => {
        btn.addEventListener('click', this._onAdd.bind(this), { once: true });
      });
    }

    _onAdd(evt) {
      const btn = evt.currentTarget;
      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.classList.add('loading');

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1,
        sections: cart ? cart.getSectionsToRender().map((s) => s.id) : [],
        sections_url: window.location.pathname
      });

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) return;
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-upsells', productVariantId: variantId });
          }
          if (cart) {
            cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.warn('Failed to add to cart:', e);
        })
        .finally(() => {
          btn.classList.remove('loading');
          btn.addEventListener('click', this._onAdd.bind(this), { once: true });
        });
    }
  });
}
